import BaseApi from './BaseApi'

export default class DevicesSettingsApi extends BaseApi {
    async getDevicesAlarmPipelinesSettings (hardwareId) {
        return this.get(`/api/v1.0/devicesSettings/alarmsPipelinesSettings/${hardwareId}`)
    }

    async createDevicesAlarmPipelinesSettings (params = {
        hardwareId: null,
        pipeline: {
            type: null,
            alarmKey: null,
            isOverriding: null
        }
    }) {
        return this.post(`/api/v1.0/devicesSettings/alarmsPipelinesSettings/`, params)
    }

    async resetDevicesAlarmPipelinesSettings (params = {
        alarmKey: null,
        hardwareId: null
    }) {
        return this.put('/api/v1.0/devicesSettings/alarmsPipelinesSettings/reset', params)
    }
}
